import {
  CommonModule,
} from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  OnInit,
  signal,
} from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-paginations",
  templateUrl: "./paginations.component.html",
  styleUrl: "./paginations.component.scss",
  imports: [CommonModule, TranslateModule],
})
export class PaginationsComponent implements OnInit {
  @Output() pageChange = new EventEmitter();

  sources: any;
  total_page: any;

  current_page = 1;
  current_loop = 1;
  max_page = 5;
  min_page = 1;

  loading = signal(true);

  #cdr = inject(ChangeDetectorRef);

  @Input()
  set dataSource(value: any) {
    if (value !== null && value !== undefined) {
      this.sources = value;
      const totalPage = Number(value.total_page ?? value.length ?? 0);
      this.total_page = Array(totalPage).fill(0);
    }
  }

  @Input() set isLoading(value: boolean) {
    this.loading.update((_) => value);
  }

  ngOnInit(): void {
    this.max_page = this.sources.page + 4;
    this.min_page = this.sources.page;
    this.current_loop = this.sources.page;
    this.current_page = this.sources.page;
  }

  changePage(page: number) {
    const current_page = this.sources.page;
    const next_page = page;
    if (next_page <= 0 || next_page > this.sources.total_page) {
      return;
    }
    if (page > current_page && page > this.current_loop + 4) {
      if (current_page < page) {
        this.sources.page = page;
        setTimeout(() => {
          this.max_page += next_page - current_page;
          this.min_page += next_page - current_page;
        }, 10);
      } else {
        this.sources.page = page;
        if (page === this.min_page) {
          setTimeout(() => {
            this.max_page = this.max_page - 1;
            this.min_page = this.min_page - 1;
            this.current_loop = this.min_page;
          }, 10);
        }
      }
      setTimeout(() => {
        this.#cdr.detectChanges();
      }, 120);
    } else if (page < current_page && page < this.min_page) {
      this.sources.page = page;

      setTimeout(() => {
        this.max_page = this.max_page - 1;
        this.min_page = this.min_page - 1;
        this.current_loop = this.min_page;
      }, 10);
      setTimeout(() => {
        this.#cdr.detectChanges();
      }, 120);
    } else {
      this.sources.page = page;
    }

    this.pageChange.emit({ page: page });
  }

  isDivisibleBy(divide_by: number, num: number): boolean {
    return num % divide_by === 0;
  }

  isDivisible(divide_by: number, num: number) {
    return num % 5;
  }
}
